import {
  Interface,
  type
} from 'implement-js'

export const RetailItemCommPrice = Interface('RetailItemCommPrice')({
  Price: type('number'),
  PriceExclTax: type('number'),
  CurrencyCode: type('string'),
  ValidFromDateTime: type('string'),
  ValidToDateTime: type('string')
}, {
    // when true, errors and warnings are triggered when properties
    // other than those on the Interface are found, is suppressed if
    // trim is set to true - default: false
    strict: true,

    // remove methods that don’t match the Interface - default: false
    trim: true,

    // throws an error when Interface isn’t implemented - default: false
    error: false,

    // warns when Interface isn’t implemented - default: true
    warn: false,
  //rename: { PropID_interface1: 'PropID_Json_response1', PropID_interface2: 'PropID_Json_response2' }
})
